// =============================================================================
// GALERIE ZDJĘĆ WYPRAW
// =============================================================================
// 1. Wrzuć pliki do: public/images/
// 2. Dodaj ścieżki poniżej (np. '/images/portugalia2026-1.webp')
// 3. Galeria pojawi się automatycznie na stronie relacji danej wyprawy
// =============================================================================

/** Tatry 2024 — /projects/hiking/tatry */
export const imagesTatry = [
  '/images/tatry.webp',
  '/images/tatry1.webp',
  '/images/tatry6.webp',
  '/images/tatry3.webp',
  '/images/tatry4.webp',
  '/images/tatry2.webp',
  '/images/tatry5.webp',
  '/images/tatry7.webp',
  '/images/tatry14.webp',
  '/images/tatry8.webp',
  '/images/tatry10.webp',
  '/images/tatry11.webp',
  '/images/tatry9.webp',
  '/images/tatry13.webp',
  '/images/tatry12.webp',
  '/images/tatry15.webp',
];

/** Málaga 2024 — /projects/hiking/malaga */
export const imagesMalaga = [
  '/images/malaga1.webp',
  '/images/malaga3.webp',
  '/images/malaga8.webp',
  '/images/malaga12.webp',
  '/images/malaga5.webp',
  '/images/malaga6.webp',
  '/images/malaga11.webp',
  '/images/malaga7.webp',
];

/** Madera 2025 — /projects/hiking/madera */
export const imagesMadera = [
  '/images/madera4.webp',
  '/images/madera6.webp',
  '/images/madera2.webp',
  '/images/madera5.webp',
  '/images/madera1.webp',
  '/images/madera3.webp',
];

/** Portugalia 2026 — /projects/hiking/2026/portugalia */
export const imagesPortugalia2026: string[] = [
  // '/images/portugalia2026-1.webp',
  // '/images/portugalia2026-2.webp',
];

/** Tatry Wysokie (Słowacja) 2026 — /projects/hiking/2026/slowacja */
export const imagesSlowacja2026: string[] = ['/images/Tatry26.webp'];

/** Tatry Wysokie 2025 — /projects/hiking/tatry2 */
export const imagesTatry2: string[] = [
  // '/images/tatry2-1.webp',
  // '/images/tatry2-2.webp',
];

/** Karkonosze — /projects/hiking/karkonosze */
export const imagesKarkonosze: string[] = [
  // '/images/karkonosze-1.webp',
];
